import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgInvoice32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path d="M19 5a1 1 0 0 1 .707.293l5 5A1 1 0 0 1 25 11v14a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm-1 1H8v19h16V12h-5.5a.5.5 0 0 1-.5-.5zm3.5 15a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1Zm0-3a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1Zm0-3a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1Zm-8.89-7c.843 0 1.32.387 1.686.912l-.643.476c-.297-.407-.58-.628-1.063-.628-.49 0-.87.324-1.064.842h1.485v.587h-1.616c-.014.097-.014.2-.014.304 0 .097 0 .187.007.276h1.623v.594h-1.492c.194.546.587.877 1.126.877.463 0 .739-.241 1.057-.663l.607.45c-.393.572-.884.973-1.67.973-1.023 0-1.741-.656-2.01-1.637H10v-.594h.532c-.007-.083-.007-.172-.007-.262 0-.104 0-.214.014-.318H10v-.587h.65C10.924 8.67 11.63 8 12.61 8M19 6v5h5z" className="invoice-32_svg__path-1" /></SvgIcon>;
};
const Memo = memo(SvgInvoice32);
export default Memo;